/* eslint-disable */
import Api from '@/repository/index'
import { Message } from 'element-ui'
import { Actions, createMapper, Getters, Module, Mutations } from 'vuex-smart-module'
import {
  GetExternalApiCredentialsSettingsResponse,
  SetupAtimoCredentialsSettingsRequest,
  UpdateDrivematicsAPICredentialsRequest,
  UpdateMozenParkTokenRequest,
  UpdateWialonAPICredentialsRequest
} from 'rikroot-types/parksmanagement/external_api_credentials_settings.pb'

export type ExternalApiCredentialsSettings = GetExternalApiCredentialsSettingsResponse
type ChangeAtimoCredentialsRequest = SetupAtimoCredentialsSettingsRequest
type ChangeMozenCredentialsRequest = UpdateMozenParkTokenRequest

export enum ParkService {
  mozen = 'MOZEN',
  yandex = 'YANDEX',
  myavo = 'MYAVO',
  atimo = 'ATIMO',
  wialon = 'WIALON',
  drivematics = 'DRIVEMATICS'
}

export const ParkServiceTranslate = {
  [ParkService.mozen]: 'Mozen',
  [ParkService.yandex]: 'Yandex',
  [ParkService.myavo]: 'My Avo',
  [ParkService.atimo]: 'Атимо',
  [ParkService.wialon]: 'Wialon',
  [ParkService.drivematics]: 'Драйвматика Яндекс'
}

export type ChangeSettingsDTO = {
  serviceName: ParkService
  value: Object
}

class ExternalApisCredsSettingsState {
  loading = false;
  externalApiCredentialsSettings: ExternalApiCredentialsSettings | null = null;
}

class ExternalApisCredsSettingsGetters extends Getters<ExternalApisCredsSettingsState> {
}

class ExternalApisCredsSettingsMutations extends Mutations<ExternalApisCredsSettingsState> {
  SET_LOADING (payload: boolean) {
    this.state.loading = payload
  }

  SET_EXTERNAL_API_CREDENTIALS_SETTINGS (payload: ExternalApiCredentialsSettings) {
    this.state.externalApiCredentialsSettings = payload
  }
}

class ExternalApisCredsSettingsActions extends Actions<ExternalApisCredsSettingsState, ExternalApisCredsSettingsGetters, ExternalApisCredsSettingsMutations, ExternalApisCredsSettingsActions> {
  async fetchExternalApiCredentialsSettings (): Promise<void> {
    this.commit('SET_LOADING', true)
    try {
      const response = await Api.externalApiCredsSettingsRepo.getExternalApiCredentialsSettings()
      if (!response) {
        throw new Error('Ошибка получения настроек')
      }
      this.commit('SET_EXTERNAL_API_CREDENTIALS_SETTINGS', response)
    } catch (e) {
      let message = 'Что-то пошло не так'

      if (typeof e === 'string') {
        message = e
      } else if (e instanceof Error) {
        message = e.message
      }

      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
    } finally {
      this.commit('SET_LOADING', false)
    }
  }

  async changeSettings (dto: ChangeSettingsDTO): Promise<void> {
    this.commit('SET_LOADING', true)
    try {
      switch (dto.serviceName) {
        case ParkService.mozen:
          await Api.externalApiCredsSettingsRepo.changeMozenCredentials(dto.value as ChangeMozenCredentialsRequest)
          break
        case ParkService.yandex:
          await Api.parkManager.settings.updateYandexTaxiAPICredentials(dto.value)
          break
        case ParkService.myavo:
          await Api.parkManager.settings.updateMyavoAPICredentials(dto.value)
          break
        case ParkService.atimo:
          await Api.externalApiCredsSettingsRepo.changeAtimoCredentials(dto.value as ChangeAtimoCredentialsRequest)
          break
        case ParkService.wialon:
          await Api.externalApiCredsSettingsRepo.changeWialonCredentials(
            dto.value as UpdateWialonAPICredentialsRequest
          )
          break
        case ParkService.drivematics:
          await Api.externalApiCredsSettingsRepo.changeYandexDrivematicsCredentials(
            dto.value as UpdateDrivematicsAPICredentialsRequest
          )
          break
        default:
          throw new Error('Неизвестный сервис')
      }

      // await fetchExternalApiCredentialsSettings()
      await this.dispatch('fetchExternalApiCredentialsSettings')
    } catch (e) {
      let message = 'Что-то пошло не так'

      if (typeof e === 'string') {
        message = e
      } else if (e instanceof Error) {
        message = e.message
      }

      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
    } finally {
      this.commit('SET_LOADING', false)
    }
  }
}

export const externalApisCredsSettings = new Module({
  namespaced: true,
  state: ExternalApisCredsSettingsState,
  getters: ExternalApisCredsSettingsGetters,
  mutations: ExternalApisCredsSettingsMutations,
  actions: ExternalApisCredsSettingsActions
})

export const externalApisCredsSettingsMapper = createMapper(externalApisCredsSettings)
